import { render, staticRenderFns } from "./BookToday.vue?vue&type=template&id=b2af87ba&scoped=true&"
import script from "./BookToday.vue?vue&type=script&lang=js&"
export * from "./BookToday.vue?vue&type=script&lang=js&"
import style0 from "./BookToday.vue?vue&type=style&index=0&id=b2af87ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2af87ba",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BookToday.vue
// module id = 178
// module chunks = 0